// extracted by mini-css-extract-plugin
export default {"confirmModalContainer":"confirmModalContainer__10OrL","loader":"loader__2_Fh3"};